import { get, post, deleteFun, put } from '@/utils/request.js';

// 部门管理

/**
 * 部门列表
 */
export function getDepartmentList(params) {
    return get('/mpp/dept/findAllAsTree', params);
}

/**
 * 部门详情
 * id
 */
export function getDepartmentById(params) {
    return get('/mpp/dept/get', params);
}

/**
 * 删除部门
 * ids 支持批量删除
 */
export function deleteDepartment(params) {
    return deleteFun('/mpp/dept/delete', params);
}



/**
 * 添加部门信息
 * mppDept
 */
export function addDept(params) {
    return post('/mpp/dept/add', params);
}



/**
 * 修改部门信息
 * mppDept
 */
 export function editDept(params) {
    return post('/mpp/dept/edit', params);
}

/**
 * 获取本部门所有用户
 * @param {*} params
 * @returns 
 */
export function getUserListByDeptId(params){
    return get('/mpp/dept/getUserListByDeptId',params);
}

/**
 * 移除部门用户
 * @param {*} params 
 * @returns 
 */
export function deleteUserFromDept(params){
    return deleteFun('/mpp/dept/deleteUserFromDept',params);
}

/**
 * 添加部门用户
 * @param {}} params 
 * @returns 
 */
export function addUserListByDeptId(params){
    return post('/mpp/dept/addUsersIntoDept',params)
}

